import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';

import {
  FINANCE_ANALYTIC_DISTRIBUTION_MODEL_ACTION_ENDPOINT,
  FINANCE_ANALYTIC_DISTRIBUTION_MODEL_ENDPOINT,
  FINANCE_ANALYTIC_DISTRIBUTION_MODELS_ENDPOINT,
  FINANCE_ANALYTIC_DISTRIBUTION_MODELS_OPTIONS_ENDPOINT,
  FINANCE_ANALYTIC_DISTRIBUTION_MODELS_SCHEMA_ENDPOINT,
} from '../../../../core/api/api-endpoints';
import { RestApiService } from '../../../../core/api/rest-api.service';
import { formatString } from '../../../../core/utils/string.utils';
import { SearchFilterSchema } from '../../../../shared/search-filter-pagination/search-bar/search-bar.types';
import { AnalyticDistributionService } from '../../../../core/services/analytic-distribution';

@Injectable({
  providedIn: 'root',
})
export class AnalyticDistributionModelApi {
  constructor(private readonly restApi: RestApiService, private readonly distributions: AnalyticDistributionService) {}

  schema(): Observable<SearchFilterSchema> {
    return this.restApi.get<SearchFilterSchema>(FINANCE_ANALYTIC_DISTRIBUTION_MODELS_SCHEMA_ENDPOINT);
  }

  options<T>(): Observable<T> {
    return this.restApi.get<T>(FINANCE_ANALYTIC_DISTRIBUTION_MODELS_OPTIONS_ENDPOINT);
  }

  list<T>(queryString = ''): Observable<T> {
    return this.restApi.get<T>(FINANCE_ANALYTIC_DISTRIBUTION_MODELS_ENDPOINT + queryString);
  }

  get<T>(id: string): Observable<T> {
    return this.restApi.get<T>(formatString(FINANCE_ANALYTIC_DISTRIBUTION_MODEL_ENDPOINT, id));
  }

  create<T>(payload: Record<string, unknown>): Observable<T> {
    return this.restApi.post<T>(FINANCE_ANALYTIC_DISTRIBUTION_MODELS_ENDPOINT, payload)
      .pipe(tap(() => this.distributions.invalidate()));
  }

  update<T>(id: string, payload: Record<string, unknown>): Observable<T> {
    return this.restApi.patch<T>(formatString(FINANCE_ANALYTIC_DISTRIBUTION_MODEL_ENDPOINT, id), payload)
      .pipe(tap(() => this.distributions.invalidate()));
  }

  archive<T>(id: string, archived: boolean): Observable<T> {
    return this.restApi.post<T>(
      formatString(FINANCE_ANALYTIC_DISTRIBUTION_MODEL_ACTION_ENDPOINT, id, archived ? 'unarchive' : 'archive'),
      {},
    ).pipe(tap(() => this.distributions.invalidate()));
  }

  delete<T>(id: string): Observable<T> {
    return this.restApi.delete<T>(formatString(FINANCE_ANALYTIC_DISTRIBUTION_MODEL_ENDPOINT, id))
      .pipe(tap(() => this.distributions.invalidate()));
  }
}
